import { makeStyles } from 'tss-react/mui'
import { buyColor, sellColor } from '../../assets/colors'
import { alpha } from '@mui/material'
import { darkHoverBtnColor, lightHoverBtnColor } from '../../theme/theme'
import type { CSSObject } from 'tss-react'


export const useStyles = makeStyles()((theme) => {
    return {
        table: {
            border: 0,
            borderSpacing: 0,
            borderCollapse: 'collapse',
            tableLayout: 'fixed',
            width: '100%'
        } as CSSObject,
        tableRow: {
            position: 'relative',
            height: '36px',
            '&:hover .action-menu': {
                visibility: 'visible'
            }
        } as CSSObject,
        headerRow: {
            borderBottom: `1px solid ${theme.palette.divider}`,
            borderColor: theme.palette.background.default,
            '& th': {
                backgroundColor: `${theme.palette.background.paper} !important`,
                position: 'sticky',
                top: 0,
                zIndex: 2
            }
        } as CSSObject,
        childRow: {
            background: alpha((theme.palette.mode === 'light') ? lightHoverBtnColor : darkHoverBtnColor, 0.3)
        } as CSSObject,
        closedPositionRow: {
            '& > td': {
                opacity: 0.5
            },
            '& > td .MuiBox-root[style*="position: absolute"]': {
                opacity: '1 !important'
            }
        } as CSSObject,
        tableCell: {
            padding: '5px',
            boxSizing: 'border-box',
            border: 0
        } as CSSObject,
        expandCell: {
            width: '5%',
            padding: 0
        } as CSSObject,
        symbolCell: {
            width: '30%',
            textWrap: "nowrap",
            overflow: 'visible'
        } as CSSObject,
        qtyCell: {
            width: '10%',
            textAlign: "right"
        } as CSSObject,
        averageCell: {
            width: '20%',
            textAlign: "right"
        } as CSSObject,
        ltpCell: {
            width: '20%',
            textAlign: "right"
        } as CSSObject,
        profitCell: {
            width: '15%',
            textAlign: "right"
        } as CSSObject,
        borderCell: {
            width: '3px !important',
            minWidth: '3px !important',
            maxWidth: '3px !important',
            padding: '0 !important',
            overflow: 'hidden'
        } as CSSObject,
        buyQuantity: {
            color: buyColor
        } as CSSObject,
        sellQuantity: {
            color: sellColor
        } as CSSObject,
        profitColor: {
            color: 'var(--green-text-color)'
        } as CSSObject,
        lossColor: {
            color: 'var(--red-text-color)'
        } as CSSObject,
    }
})
